import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyImport extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} pageTitle={"Import Log"} formname={"table_72"} customClass={"field-customization-container org-container"} customFrameClass = {"import-log-container"}/>
        );
    }
}

export default LegacyImport;
